import { useBoardsStore } from "@/store/boards";
import { useConnectionStore } from "@/store/connection";
import { useLoadingStore } from "@/store/loading";
import { useUserStore } from "@/store/user";

import type { Connection } from "./Connection";
import { HttpRpcBackend } from "./impl/HttpRpcBackend";
import { NatsBackendSession } from "./impl/NatsBackendSession";
import { NatsRpcBackend } from "./impl/NatsRpcBackend";
import { SwitchingRpcBackend } from "./impl/SwitchingRpcBackend";
import { saveBackendSession } from "./impl/backendSessionCache";
import { initBackendReader, reconnect } from "./read/BackendReader";
import { writer } from "./write/BackendWriter";

const httpCallPaths = ["link.list"];

export async function startBackendSession(connection: Connection) {
  await initNatsSession(connection);
  useConnectionStore().connectWebsocket();
  if (useBoardsStore().boardsInited) {
    reconnect();
  }
}

async function initNatsSession(connection: Connection) {
  const natsRpcBackend = new NatsRpcBackend(
    connection,
    useUserStore().technicalUser.company,
    useUserStore().technicalUser.id,
  );
  const rpcBackend = new SwitchingRpcBackend([natsRpcBackend, new HttpRpcBackend()], (path) =>
    useHttp(path) ? 1 : 0,
  );
  const session = new NatsBackendSession(connection, useUserStore().technicalUser, rpcBackend);
  await useLoadingStore().load("initBackend", initReaderAndWriter(session));
  return session;
}

function useHttp(path: string) {
  return httpCallPaths.includes(path);
}

async function initReaderAndWriter(session: NatsBackendSession) {
  saveBackendSession(session);
  await initBackendReader(session);
  writer.initSession(session);
}
